import { useState } from "react";
import { Bot, LogIn, Lock, Mail } from "lucide-react";
import { http, errMsg } from "@/lib/api";
import useBranding from "@/hooks/useBranding";

const BG = "https://images.unsplash.com/photo-1556056504-5c7696c4c28d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login({ onLogin }) {
  const { name } = useBranding();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(errMsg(err));
    }
    setBusy(false);
  };

  const field = "w-full bg-slate-950 border border-slate-800 rounded-md pl-10 pr-3 py-3 text-sm focus:outline-none focus:border-[var(--gold)] transition-colors";

  return (
    <div className="relative z-10 min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex items-end p-12" style={{ backgroundImage: `linear-gradient(0deg,#0A0F1D 10%,rgba(10,15,29,.4)),url(${BG})`, backgroundSize: "cover", backgroundPosition: "center" }}>
        <h1 data-testid="login-brand-name" className="font-display text-6xl font-extrabold uppercase leading-[0.9] fade-up">{name}</h1>
      </div>
      <div className="flex items-center justify-center p-6">
        <form data-testid="login-form" onSubmit={submit} className="panel w-full max-w-md p-8 space-y-5 fade-up">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[var(--gold)] text-slate-950 grid place-items-center"><Bot size={22} strokeWidth={2.5} /></div>
            <div>
              <div className="font-display text-2xl font-extrabold uppercase leading-none">Area Admin</div>
              <div className="text-[11px] font-mono text-slate-400 tracking-wider">ACCEDI PER GESTIRE IL BOT</div>
            </div>
          </div>
          <label className="block relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input data-testid="login-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          </label>
          <label className="block relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input data-testid="login-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
          </label>
          {error && <p data-testid="login-error" className="text-sm text-[var(--loss)]">{error}</p>}
          <button data-testid="login-submit-button" disabled={busy} className="btn btn-gold w-full justify-center py-3">
            <LogIn size={16} /> {busy ? "Accesso..." : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
}
